var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: `代理账单详情-${_vm.rowData.supplierName}`,
        visible: _vm.dialogFormVisible,
        width: "1400px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": "",
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogFormVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("BaseTable", {
            attrs: {
              height: 600,
              tableData: _vm.tableData,
              isPager: false,
              loading: _vm.loading,
              "element-loading-text": "系统处理中，请稍等...",
            },
          }),
          _c("p", { staticClass: "tips" }, [
            _c("span", [
              _vm._v(" 共选择 "),
              _c("span", { staticStyle: { color: "#fe453d" } }, [
                _vm._v(_vm._s(_vm.tableData.columns.length)),
              ]),
              _vm._v(" 条数据 "),
            ]),
            _c("span", [
              _vm._v(" 合计： "),
              _c("span", { staticStyle: { color: "#fe453d" } }, [
                _vm._v(_vm._s(_vm.sumAmount)),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }